<form novalidate #motorsVehicleTransferOptionsSectionForm="ngForm">
  @if (draftLoaded$ | async) {
    <tg-row
      class="motors-listing-details-page__section"
      >
      <tg-col sm="12" lg="4">
        <tg-radio-group
          name="vehicle-transfer-options"
          label="Vehicle transfer options"
          (change)="publish()"
          required
          [(ngModel)]="draftData.listingDetails.vehicleTransferOption"
                [validation]="
                    validation.listingDetails.vehicleTransferOption
                        | toValidator
                "
          [disabled]="inputDisabled"
          >
          <tg-radio-item [value]="1" label="Buyer must pick up">
          </tg-radio-item>
          <tg-radio-item [value]="2" label="Buyer can pick up">
          </tg-radio-item>
          <tg-radio-item [value]="3" label="To be arranged">
          </tg-radio-item>
        </tg-radio-group>
      </tg-col>
    </tg-row>
  }
</form>
